var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"m-panel"},[_c('h3',{staticClass:"m-panel__title"},[_vm._v(_vm._s(_vm.data.attrs.title))]),_c('div',{staticClass:"m-panel__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }